import CardHeader from "../atoms/CardHeader";
import Breadcrumb from "../molecules/Breadcrumb";
import EditPerfilForm from "../organisms/perfil/EditPerfilForm";

const PerfilTemplate = () => {
    return (
        <div className="flex flex-col gap-4">
            <CardHeader
                left={
                    <Breadcrumb
                        items={[
                            { label: "Inicio", to: "/inicio" },
                            { label: "Perfil", to: null },
                        ]}
                    />
                }
            />
            <EditPerfilForm/>
        </div>
    );
};

export default PerfilTemplate;